export const resizeBase64 = async (
  base64: string,
  width: number,
  height: number
) => {
  let canvas = document.createElement("canvas");
  let ctx = canvas.getContext("2d")!;
  let canvasCopy = document.createElement("canvas");
  let ctxCopy = canvasCopy.getContext("2d")!;

  const img = new Image();
  img.src = base64;

  return new Promise((resolve: (selected: string) => void, reject) => {
    img.onload = async () => {
      canvasCopy.width = img.width;
      canvasCopy.height = img.height;
      ctxCopy.drawImage(img, 0, 0);

      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(
        canvasCopy,
        0,
        0,
        canvasCopy.width,
        canvasCopy.height,
        0,
        0,
        canvas.width,
        canvas.height
      );

      resolve(canvas.toDataURL());
    };
  });
};
